// 内容管理状体存储
const state = {
  processIndex: Number(sessionStorage.getItem('processIndex')) || 1, //评测步骤
  basicInfo: {}, //基本信息对象
  question: [], //第二步问题
  answer: [], // 第三步答案
  contentInfo: {}, //编辑数据
  contentType: '0', //自建内容类型 0-图文 1-评测
  prevFlag: false, // 是否返回上一步，用于解决返回上一步不再请求接口
  editTag: [], //编辑时，已选的标签
  guideFlag: false,
  contentImages: [], // 正文图片
}

const getters = {
  processIndex: state => state.processIndex,
  basicInfo: state => {
    if (sessionStorage.getItem('basicInfo')) {
      state.basicInfo = JSON.parse(sessionStorage.getItem('basicInfo'))
    }
    return state.basicInfo
  },
  question: state => {
    if (sessionStorage.getItem('question')) {
      state.question = JSON.parse(sessionStorage.getItem('question'))
    }
    return state.question
  },
  answer: state => {
    if (sessionStorage.getItem('answer')) {
      state.answer = JSON.parse(sessionStorage.getItem('answer'))
    }
    return state.answer
  },
  contentInfo: state => {
    if (sessionStorage.getItem('contentInfo')) {
      state.contentInfo = JSON.parse(sessionStorage.getItem('contentInfo'))
    }
    return state.contentInfo
  },
  contentType: state => {
    return state.contentType
  },
  prevFlag: state => {
    return state.prevFlag
  },
  editTag: state => {
    // if (sessionStorage.getItem('editTag')) {
    //   state.editTag = JSON.parse(sessionStorage.getItem('editTag'))
    // }
    return state.editTag
  },
  guideFlag: state => {
    return state.guideFlag
  },
  contentImages: state => {
    return state.contentImages
  }
}

const mutations = {
  setProcessIndex: (state, param) => {
    sessionStorage.setItem('processIndex', param)
    state.processIndex = sessionStorage.getItem('processIndex')
  },
  setBasicInfo: (state, param) => {
    state.basicInfo = param
    sessionStorage.setItem('basicInfo', JSON.stringify(param))
  },
  setQuestion: (state, param) => {
    state.question = param
    sessionStorage.setItem('question', JSON.stringify(param))
  },
  setAnswer: (state, param) => {
    state.answer = param
    sessionStorage.setItem('answer', JSON.stringify(param))
  },
  setContentInfo: (state, param) => {
    state.contentInfo = param
    sessionStorage.setItem('contentInfo', JSON.stringify(contentInfo))
  },
  setContentType: (state, param) => {
    state.contentType = param
  },
  setPrevFlag: (state, param) => {
    state.prevFlag = param
  },
  setEditTag: (state, param) => {
    state.editTag = param
    // sessionStorage.setItem('editTag', JSON.stringify(param))
  },
  setGuideFlag: (state, param) => {
    state.guideFlag = param
  },
  setContentImage: (state, param) => {
    state.contentImages = param
  }
}

const actions = {
  
}
export default {
  state,
  getters,
  mutations,
  actions
}